import React, { Component } from 'react'

const withShowHideContent = wrappedComponent => {
  class ShowHideContent extends Component {
    constructor(props) {
      super(props)
      this.state = {
        open: props.open,
      }
    }

    toggle() {
      this.setState({
        open: !this.state.open,
      })
    }

    render() {
      return React.createElement(wrappedComponent, {
        ...this.props,
        open: this.state.open,
        toggle: this.toggle.bind(this),
      })
    }
  }

  return ShowHideContent
}

export default withShowHideContent



// WEBPACK FOOTER //
// ./src/ui/show-hide/container.js